import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {BlacklistService} from '../../../shared/service/blacklist.service';
import {ApprovalModel} from '../../../shared/dto/approval.model';
import swal, {default as Swal} from 'sweetalert2';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {SuspendService} from '../../../shared/service/suspend.service';
import {ActionMode} from '../../../shared/enums/action-mode.enum';
import {ReversedSuspendService} from '../../../shared/service/reversed-suspend.service';
import {SuspendBlacklistService} from '../../../shared/service/suspend-blacklist.service';

@Component({
  selector: 'app-return-request-details',
  templateUrl: './return-request-details.component.html',
  styleUrls: ['./return-request-details.component.scss']
})
export class ReturnRequestDetailsComponent implements OnInit {

  remarkForm: FormGroup;
  @Input() fromParent;
  approvalModel: ApprovalModel = new ApprovalModel();
  isError: boolean = false;
  isSucess: boolean = false;
  public applicentType:string;

  constructor(private blacklistService: BlacklistService, private router: Router,private activeModal: NgbActiveModal ,
              private suspendService: SuspendService, private reversedSuspendService: ReversedSuspendService,
              private suspendBlacklistService: SuspendBlacklistService) { }

  ngOnInit() {
    this.approvalModel = this.fromParent.model;
    this.applicentType = this.fromParent.appType;
    this.remarkForm = new FormGroup({
      remark: new FormControl(null),
    });
  }

  submitRequest() {
    this.approvalModel.remark = this.remarkForm.value.remark;

    // alert(this.approvalModel.process);/

    if(this.approvalModel.process === ActionMode.SUSPEND) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to return the request?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {
          // alert(this.applicentType);
          this.suspendService.returnRequest(this.approvalModel).subscribe(
            (success: string) => {
              swal.fire('Success', 'Applicant Details Updated', 'success');
              this.activeModal.close({status: 'Saved', data: ""});

              if (this.router.url.includes('/dashboard/suspend-return-data/')) {
                if(this.approvalModel.userRole == "EXM"){
                  this.router.navigate(['/dashboard/suspend-return/', this.applicentType]);
                }else {
                  this.router.navigate(['/dashboard/suspend-return-datas/', this.applicentType]);
                }
              } else if (this.router.url.includes('/dashboard/reversed-suspend-return-data/')) {

                this.router.navigate(['/dashboard/reversed-suspend-return-datas/', this.applicentType]);
              }
              else if (this.router.url.includes('/dashboard/suspend-authorization/')) {
                this.router.navigate(['/dashboard/suspend-authorizations/', this.applicentType]);
              }
              this.blacklistService.close();
            },
            (error) => {
              swal.fire('Error', 'Error When Updating the Request', 'error');
            },
          );
        } else {
        }
      });

    }else if(this.approvalModel.process === ActionMode.REVERSE_SUSPEND){

      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to return the request?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {

          this.reversedSuspendService.returnRequest(this.approvalModel).subscribe(
            (success: string) => {
              swal.fire('Success', 'Applicant Details Updated', 'success');
              this.activeModal.close({status: 'Saved', data: ""});

              if (this.router.url.includes('/dashboard/suspend-return-data/')) {
                this.router.navigate(['/dashboard/suspend-return-data', this.applicentType]);

              } else if (this.router.url.includes('/dashboard/reversed-suspend-return-data/')) {
                this.router.navigate(['/dashboard/reversed-suspend-return-datas', this.applicentType]);
              }
              this.blacklistService.close();
            },
            (error) => {
              swal.fire('Error', 'Error When Updating the Request', 'error');
            },
          );
        } else {
        }
      });

    }else {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to return the request?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {

          // alert("asdddddddddddddddddddd");

          console.log(this.applicentType+"this.applicentType");

          this.blacklistService.returnRequest(this.approvalModel).subscribe(
            (success: string) => {
              swal.fire('Success', 'Applicant Details Updated', 'success');
              this.activeModal.close({ status: 'Saved', data: "" });

              if(this.router.url.includes('/dashboard/blacklist-authorization/')) {
                this.router.navigate(['/dashboard/blacklist-authorizations', this.applicentType]);

              }else if(this.router.url.includes('/dashboard/blacklist-return/')){
                this.router.navigate(['/dashboard/return-request-data', this.applicentType]);

              }else if(this.router.url.includes('/dashboard/suspend-verification/')){
                this.router.navigate(['/dashboard/suspend-verifications', this.applicentType]);

              }else if(this.router.url.includes('/dashboard/suspend-authorization/')) {
                this.router.navigate(['/dashboard/suspend-authorizations', this.applicentType]);

              }else if(this.router.url.includes('/dashboard/blacklist-verification/')) {
                if(this.approvalModel.userRole == "EXM"){
                  this.router.navigate(['/dashboard/blacklist-verifications/', this.applicentType]);
                }else{
                  this.router.navigate(['/dashboard/blacklist-verification', this.applicentType]);
                }
              }else if(this.router.url.includes('/dashboard/reversed-blacklist-return/')) {
                this.router.navigate(['/dashboard/reversed-return-request-data', this.applicentType]);
              }
              else if (this.router.url.includes('/dashboard/reversed-suspend-blacklist-return-data/')) {
                this.router.navigate(['/dashboard/reversed-suspend-blacklist-return-data', this.applicentType]);
              }
              else if (this.router.url.includes('/dashboard/suspend-blacklist-verification/')) {
                this.router.navigate(['/dashboard/suspend-blacklist-verification', this.applicentType]);
              }
              else if (this.router.url.includes('/dashboard/suspend-blacklist-authorization/')) {
                this.router.navigate(['/dashboard/suspend-blacklist-authorization', this.applicentType]);
              }
              else if (this.router.url.includes('/dashboard/suspend-blacklist-return/')) {
                this.router.navigate(['/dashboard/suspend-return-request-data', this.applicentType]);
              }

              this.blacklistService.close();
            },
            (error) => {
              swal.fire('Error', 'Error When Updating the Request', 'error');
            },
          );
        } else {
        }
      });
    }
  }

}
